<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    persistent
    :width="dialogWidth"
    v-bind="$attrs"
  >
    <v-card class="mx-auto" :max-width="dialogWidth">
      <v-card-text class="text-center">
        <br />
        <i :class="iconClass" :style="iconStyle"></i>
      </v-card-text>
      <v-card-title class="d-flex justify-content-center">
        <p
          class="text-center font-weight-bold display-2"
          style="word-break: normal;"
        >
          {{ alertTitle }}
        </p>
      </v-card-title>
      <v-card-text v-if="text" class="d-flex justify-content-center">
        <div
          v-if="isHtml"
          class="text-center headline text--primary"
          style="word-break: normal;"
          v-html="text"
        ></div>
        <p
          v-else
          class="text-center headline text--primary"
          style="word-break: normal;"
        >
          {{ text }}
        </p>
      </v-card-text>
      <v-card-actions class="d-flex justify-content-center">
        <v-btn @click="dismiss" large color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const ERROR = "error",
  INFORMATION = "information",
  SUCCESS = "success",
  WARNING = "waring";

const alertTypes = {
  [WARNING]: {
    icon: "fa-exclamation-triangle text-danger",
    colour: "",
    title: "Warning"
  },
  [INFORMATION]: {
    icon: "fa-info-circle text-secondary",
    colour: "",
    title: "Be Advised"
  },
  [SUCCESS]: {
    icon: "fa-check-circle text-success",
    colour: "",
    title: "Success"
  },
  [ERROR]: {
    icon: "fa-exclamation-triangle text-danger",
    colour: "",
    title: "Error"
  }
};

export default {
  ERROR,
  INFORMATION,
  SUCCESS,
  WARNING,
  props: {
    iconSize: {
      type: Number,
      required: false,
      default: 8
    },
    dialogWidth: {
      type: Number,
      required: false,
      default: 400
    },
    type: {
      String,
      required: false,
      default: INFORMATION
    },
    iconColour: {
      type: String,
      required: false,
      default: ""
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    text: {
      type: String,
      required: false,
      default: ""
    },
    btnText: {
      type: String,
      required: false,
      default: "OK"
    },
    isHtml: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    selectedIcon() {
      return !!alertTypes[this.type]
        ? alertTypes[this.type]
        : alertTypes.warning;
    },
    iconStyle() {
      const color = !!this.iconColour
        ? this.iconColour
        : this.selectedIcon.colour;
      return {
        color
      };
    },
    iconClass() {
      return ["fas", this.selectedIcon.icon, `fa-${this.iconSize}x`, "fa-fw"];
    },
    alertTitle() {
      return !!this.title ? this.title : this.selectedIcon.title;
    },
    buttonText() {
      return !!this.btnText ? this.btnText : "OK";
    }
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
      this.$emit("dismiss");
    }
  }
};
</script>
